module.exports = __webpack_public_path__ + "static/flags/TV-2281a347f698e9246a39869b395b48c8.gif";